import React, { useState, useEffect } from "react";
import logo from '../assets/logoms.PNG'; // optionnel


export default function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [menuOpen, setMenuOpen] = useState(false);

  // 🔹 détecte les changements de taille d'écran
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <div className="logo">
          <div className="logo-mark"><img src={logo} alt="MS" /></div>
          <div className="logo-text">MS Multiservices</div>
        </div>

        {!isMobile ? (
          // 🔹 Version Desktop classique
          <nav className="nav">
            <a href="#services">Services</a>
            <a href="#realisation">Réalisations</a>
            <a href="#about">À propos</a>
            <a className="btn-quote" href="#contact">
              Devis
            </a>
          </nav>
        ) : (
          // 🔹 Version Mobile avec burger
          <div className="burger-menu">
            <button
              className="burger-btn"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ☰
            </button>

            {menuOpen && (
              <div className="mobile-nav">
                <a href="#services" onClick={() => setMenuOpen(false)}>
                  Services
                </a>
                <a href="#realisations" onClick={() => setMenuOpen(false)}>
                  Réalisations
                </a>
                <a href="#about" onClick={() => setMenuOpen(false)}>
                  À propos
                </a>
                <a
                  href="#contact"
                  className="btn-quote"
                  onClick={() => setMenuOpen(false)}
                >
                  Devis
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
